import FaqContainer from "../../../Components/Miscellaneous/FAQ/FAQContainer";

const FAQ = () => {
  return <FaqContainer />;
};

export default FAQ;
